<template>
  <el-card shadow="never" class="aui-card--fill">
    <div slot="header" class="aui-card__header">
      <h3>需充值的资方统计</h3>
      <div class="header-right">
        <div class="warn_tip">
          <img style="margin-right: 10px;" src="../../../assets/img/waring.svg" alt="">
          <div>欠费<span style="font-size: 20px;">{{infoList.length>0 ? infoList[1].value : 0}}小时</span>系统自动禁止资方放款</div>
        </div>
        <div @click="goParameter">
          <img src="../../../assets/img/edit.svg" alt="">
        </div>
      </div>
    </div>
    <div class="status">
      <div class="status_item">
        <div class="s_number">{{balanceLessThanTotal}}</div>
        <div class="s_text">余额少于￥{{infoList.length>0 ?infoList[0].value :0}}（个）</div>
      </div>
      <div class="status_item">
        <div class="s_number">{{arrearageTotal}}</div>
        <div class="s_text">欠费的资方</div>
      </div>
      <div class="status_item">
        <div class="s_number">{{suspendTotal}}</div>
        <div class="s_text">账户暂停</div>
      </div>
    </div>
    <el-table
        v-loading="dataListLoading"
        :data="dataList"
        style="width: 100%"
    >
    <el-table-column prop="enterpriseName" label="资金方" header-align="center" align="center"></el-table-column>
    <el-table-column width="550" prop="availableBalance" label="平台账户可用余额" header-align="center" align="center">
      <template slot-scope="scope">
        
        <div class="balance">
          <div>
            <div>0.00</div>
            <div class="gap">
              <div class="gap_left" v-if="scope.row.availableBalance>0" :style="{width:(scope.row.availableBalance/infoList[0].value)*200+'px'}"></div>
              <div class="gap_right"v-if="scope.row.availableBalance<0" :style=" (-scope.row.availableBalance)>infoList[0].value ? 'width:200px' : { width:((-scope.row.availableBalance)/infoList[0].value)*200+'px'}"></div>
            </div>
          </div>
          <div>{{scope.row.availableBalance.toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</div>
        </div>
      </template>
    </el-table-column>
    <el-table-column prop="status" label="账户状态" header-align="center" align="center">
      <template slot-scope="scope">
        <div class="account_status" v-if="scope.row.availableBalance<0">
          <div>已欠费{{scope.row.arrearageHour}}小时</div>
          <div>
            <span v-if="scope.row.status=='0'">正常</span>
            <span class="block_up" v-if="scope.row.status=='1'">已停用</span>
          </div>
        </div>
        <div v-else>正常</div>
      </template>
    </el-table-column>
  </el-table>
  <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="parseInt(total)"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
  </el-card>
</template>
<script>
import mixinViewModule from '@/mixins/view-module'
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      infoList:[],
      balanceLessThanTotal:'',
      arrearageTotal:'',
      suspendTotal:'',
      mixinViewModuleOptions: {
        getDataListURL: `/system/platformAccount/pageList`,
        getDataListIsPage: true,
        multilist:true,

      },
    }
  },
  watch: {
    $route(to, from) {
      if (to.path == '/loan-recharge') {
        this.getInfo()
        this.getDataList()
      }
    }
  },
  created(){
    this.getInfo()
  },
  methods: {
    getInfo(){
      this.$http.get(`/system/config/list`).then(res=>{
        if(res.data.code != 0){
          return this.$message.error(res.data.msg)
        }
        this.infoList = res.data.data
      })
      this.$http.get(`/system/platformAccount/selectPlatformAccountCounts`).then(res=>{
        if(res.data.code != 0){
          return this.$message.error(res.data.msg)
        }
        this.balanceLessThanTotal = res.data.data.balanceLessThanTotal
        this.arrearageTotal = res.data.data.arrearageTotal
        this.suspendTotal = res.data.data.suspendTotal
        
      })
    },
    
    goParameter(){
      console.log(12);
      this.$router.push({path:'/loan-parameter'})
    }
  }
}
</script>
<style scoped lang="scss">
.aui-card__header{
  display: flex;
  justify-content: space-between;
  align-items: center;
  .header-right{
    display: flex;
    align-items: center;
    .warn_tip{
      background-color:  rgba(245, 154, 35, 0.18);
      color: #0045ff;
      font-size: 16px;
      display: flex;
      align-items: center;
      padding: 2px 20px;
      margin-right: 16px;
    }
  }
}
.status{
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin: 30px 0;
  .status_item{
    text-align: center;
    color: #282d31;
    .s_number{
      font-size: 34px;
      font-weight: bold;
      line-height: 50px;
    }
    .s_text{
      font-size: 16px;
      font-weight: bold;
    }
  }
}
.balance{
  display: flex;
  align-items: flex-end;
  margin-left: 50px;
}
.gap{
  width: 400px;
  height: 15px;
  border-radius: 5px;
  background-color: #e2e3f0;
  margin-right: 10px;
  position: relative;
  .gap_left{
    width: 180px;
    height: 15px;
    border-radius: 5px;
    background-color: #2169fe;
    top: 0;
    right: 50%;
    position: absolute;
  }
  .gap_right{
    width: 150px;
    height: 15px;
    border-radius: 5px;
    background-color: #e85441;
    top: 0;
    left: 50%;
    position: absolute;
  }
}
.block_up{
  color: #e85441;
  background-color:  rgba(232, 84, 65, 0.15);
  padding: 2px 6px;
  border-radius: 2px;
}
.account_status{
  display: flex;
  justify-content: space-around;
  align-items: center;
}
::v-deep .el-table td{
  border: none;
}

</style>